var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangel1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 338,
    viewBox: "0 0 379 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.611 58.7472L231.284 36.0591L243.139 153.469L161.611 58.7472Z",
    fill: "url(#paint0_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.647 59.0008L154.781 126.16L243.139 153.324L161.647 59.0008Z",
    fill: "url(#paint1_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.632 39.7469L372.258 103.414L294.151 108.473L363.632 39.7469Z",
    fill: "url(#paint2_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.638 39.3633L319.991 29.9354L294.139 108.473L363.638 39.3633Z",
    fill: "url(#paint3_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.063 152.014L201.739 204.949L129.347 270.803L157.063 152.014Z",
    fill: "url(#paint4_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.149 151.078L109.685 176.553L129.404 270.409L157.149 151.078Z",
    fill: "url(#paint5_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5743 27.0409L106.519 56.2074L46.1378 146.034L50.5743 27.0409Z",
    fill: "url(#paint6_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.374 22.1204L8.46174 65.8158L47.7717 143.814L52.374 22.1204Z",
    fill: "url(#paint7_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.699 185.671L298.11 242.741L227.247 254.93L285.699 185.671Z",
    fill: "url(#paint8_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.711 185.319L245.231 181.014L227.242 254.93L285.711 185.319Z",
    fill: "url(#paint9_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7153 214.167L95.4859 260.275L51.6728 262.541L87.7153 214.167Z",
    fill: "url(#paint10_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7236 213.989L57.9211 213.736L51.6718 262.54L87.7236 213.989Z",
    fill: "url(#paint11_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.522 312.291L211.669 332.572L199.452 290.784L241.522 312.291Z",
    fill: "url(#paint12_linear_59_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.522 312.291L234.453 283.394L199.452 290.784L241.522 312.291Z",
    fill: "url(#paint13_linear_59_2468)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_2468",
    x1: 230.308,
    y1: 36.1116,
    x2: 150.153,
    y2: 56.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_2468",
    x1: 229.528,
    y1: 55.3686,
    x2: 144.645,
    y2: 83.3271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_2468",
    x1: 360.526,
    y1: 39.912,
    x2: 290.097,
    y2: 70.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_2468",
    x1: 353.779,
    y1: 28.1284,
    x2: 285.948,
    y2: 51.0529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_2468",
    x1: 190.803,
    y1: 150.199,
    x2: 116.699,
    y2: 167.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_2468",
    x1: 150.591,
    y1: 151.432,
    x2: 101.056,
    y2: 159.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_2468",
    x1: 84.4815,
    y1: 11.2829,
    x2: 9.461,
    y2: 52.0946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_2468",
    x1: 45.668,
    y1: 25.2433,
    x2: -6.52102,
    y2: 47.5238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_2468",
    x1: 287.458,
    y1: 185.577,
    x2: 221.468,
    y2: 211.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_2468",
    x1: 277.446,
    y1: 179.288,
    x2: 219.131,
    y2: 196.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_2468",
    x1: 88.7403,
    y1: 214.112,
    x2: 46.8413,
    y2: 228.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_2468",
    x1: 82.6494,
    y1: 212.409,
    x2: 46.2477,
    y2: 222.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_2468",
    x1: 235.42,
    y1: 289.615,
    x2: 196.193,
    y2: 303.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3A6D84",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A276E",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_59_2468",
    x1: 235.315,
    y1: 283.366,
    x2: 200.207,
    y2: 301.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangel1);
export default __webpack_public_path__ + "static/media/triangel1.b40f1ad598b801b4fc7efb7b1ede9438.svg";
export { ForwardRef as ReactComponent };